/* tslint:disable */
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as E from "linq";
import { Observable } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { delay, filter, map } from 'rxjs/operators';
import { CompanyDto } from 'src/portal/search-api/models/company-dto';
import { CompanyFacetDto } from 'src/portal/search-api/models/company-facet-dto';
import { ApiConfiguration } from '../portal/search-api/api-configuration';
import { BaseService } from '../portal/search-api/base-service';
import { CompanyPageRequestDto } from '../portal/search-api/models/company-page-request-dto';
import { CompanyPageResponseDto } from '../portal/search-api/models/company-page-response-dto';
import { RequestBuilder } from '../portal/search-api/request-builder';
import { StrictHttpResponse } from '../portal/search-api/strict-http-response';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findCompanies
   */
  static readonly FindCompaniesPath = '/companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findCompanies()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findCompanies$Response(params?: {
      body?: CompanyPageRequestDto
  }): Observable<StrictHttpResponse<CompanyPageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.FindCompaniesPath, 'post');
    if (params) {


      rb.body(params.body, 'application/json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyPageResponseDto>;
      })
    );
  }

  private i = 0;

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findCompanies$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findCompanies(params?: {
      body?: CompanyPageRequestDto
  }): Observable<CompanyPageResponseDto> {

    //if (params?.body?.sort && params?.body?.sort[0]?.field == "industry") return throwError(new HttpErrorResponse({ statusText: "fjfjfjfjfjf" }))

    const companyFacetDto: CompanyFacetDto = {
      employeeRange: ["Accountants", "Automotive"],
      industry: E.repeat("Accountants", 50).toArray(),
      ownership: ["General Management", "Marketing"],
      revenueRange: ["General Management", "Marketing"],
    }

    const companyDto = (): CompanyDto => ({
      activeContacts: this.i++,
      city: "Columbus",
      companyName: "Salesforce Training",
      country: "United States",
      id: "100",
      industry: "Schools And Education Services",
      logo: "logo",
      revenueRange: "$1 Million - $10 Million",
      state: "State",
      updated: "10/01/13",
      website: "website",
    })

    const response: CompanyPageResponseDto = {
      content: E.repeat(companyDto(), 250).toArray(),
      facets: companyFacetDto,
      totalElements: 250,
      totalPages: 5,
    };

    return of(this.data).pipe(delay(1000));
  }

  private data: CompanyPageResponseDto = {
    "totalElements": 1177,
    "totalPages": 12,
    "content": [
        {
            "id": "0FAFF835F6D6162C0D85661D95F007DE",
            "logo": null,
            "website": "adacollc.com",
            "companyName": "adaco services, llc",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": "(406) 821-0096",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Hamilton",
            "state": "MT",
            "country": "US",
            "updated": null
        },
        {
            "id": "D72D218561C10C57A2B1D912E2B9BECC",
            "logo": null,
            "website": "adacautomotive.com",
            "companyName": "adac automotive",
            "industry": "Automotive",
            "revenueRange": "$500MM-1B",
            "phone": "(616) 957-0311",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Grand Rapids",
            "state": "MI",
            "country": "US",
            "updated": null
        },
        {
            "id": "3ED72281540A46A6E5B48610A7088282",
            "logo": null,
            "website": "ad2atx.com",
            "companyName": "ad2atx",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(512) 472-6662",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Austin",
            "state": "TX",
            "country": "US",
            "updated": null
        },
        {
            "id": "450131C1DF9BB2068BF6AE8CE36C3435",
            "logo": null,
            "website": "acxiomit.com",
            "companyName": "acxiom it",
            "industry": "",
            "revenueRange": "Over $1B",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Downers Grove",
            "state": "IL",
            "country": "US",
            "updated": null
        },
        {
            "id": "65097C76F5A7A32180F0643573747515",
            "logo": null,
            "website": "acxiom.com",
            "companyName": "acxiom corp",
            "industry": "Information Technology & Services",
            "revenueRange": "Over $1B",
            "phone": "(501) 342-1000",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Rochester",
            "state": "NY",
            "country": "US",
            "updated": null
        },
        {
            "id": "1DD029BF8ADC38372F069264B41636DC",
            "logo": null,
            "website": "acxpacific.com",
            "companyName": "acx pacific northwest inc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(310) 241-6229",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Bakersfield",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "12A683470DA25DEDB27EC5D11A178CF6",
            "logo": null,
            "website": "acvenviro.com",
            "companyName": "acv enviro",
            "industry": "Environmental Services",
            "revenueRange": "$50-100MM",
            "phone": "(508) 872-5000",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Quantico",
            "state": "MD",
            "country": "US",
            "updated": null
        },
        {
            "id": "272DAEC7E99D1D0B006124748CABECEA",
            "logo": null,
            "website": "acuvate.com",
            "companyName": "acuvate software",
            "industry": "Computer Software",
            "revenueRange": "$50-100MM",
            "phone": "(913) 937-7890",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "New York",
            "state": "NY",
            "country": "US",
            "updated": null
        },
        {
            "id": "6A8E1E283D41571D56F8EA7B36D0FBA7",
            "logo": null,
            "website": "acutenursingsolutions.com",
            "companyName": "acute nursing solutions llc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(480) 699-5612",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Tempe",
            "state": "AZ",
            "country": "US",
            "updated": null
        },
        {
            "id": "92F1B660F6EF997E019CFFDFBE2E8DC5",
            "logo": null,
            "website": "acuteinnovations.com",
            "companyName": "acute innovations llc",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": "(503) 686-7200",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Hillsboro",
            "state": "OR",
            "country": "US",
            "updated": null
        },
        {
            "id": "50A2B54283C513193B19514543E9DF17",
            "logo": null,
            "website": "acutept.org",
            "companyName": "acute care section -apta, inc",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": "(412) 727-1736",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Pittsburgh",
            "state": "PA",
            "country": "US",
            "updated": null
        },
        {
            "id": "41B7E6021C15202D774C871617242334",
            "logo": null,
            "website": "acut.com",
            "companyName": "acut",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Pepperell",
            "state": "MA",
            "country": "US",
            "updated": null
        },
        {
            "id": "266B1BB6537CC12492DD8943B236E7A3",
            "logo": null,
            "website": "acusisphilippines.com",
            "companyName": "acusis philippines inc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(412) 209-1300",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Pittsburgh",
            "state": "PA",
            "country": "US",
            "updated": null
        },
        {
            "id": "8B61B97E7C1C8BD8E9814F08DE0F743F",
            "logo": null,
            "website": "acusis.com",
            "companyName": "acusis llc",
            "industry": "Hospital & Health Care",
            "revenueRange": "$500MM-1B",
            "phone": "(412) 209-1300",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Pittsburgh",
            "state": "PA",
            "country": "US",
            "updated": null
        },
        {
            "id": "E07A9ADE2FCEE38DAB632F10B77D462C",
            "logo": null,
            "website": "precixinc.com",
            "companyName": "acushnet rubber company",
            "industry": "Style and Fashion",
            "revenueRange": "$50-100MM",
            "phone": "(508) 998-4000",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Southgate",
            "state": "MI",
            "country": "US",
            "updated": null
        },
        {
            "id": "A5190A1BD145116F58A5CAAD4CF00343",
            "logo": null,
            "website": "acushnet.com",
            "companyName": "acushnet company",
            "industry": "Sporting Goods",
            "revenueRange": "$500MM-1B",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Fairhaven",
            "state": "MA",
            "country": "US",
            "updated": null
        },
        {
            "id": "A702CC94CE77844208EF030DEDFF48F5",
            "logo": null,
            "website": "acushnetcompany.com",
            "companyName": "acushnet company",
            "industry": "Sporting Goods",
            "revenueRange": "$500MM-1B",
            "phone": "(508) 979-2000",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Fairhaven",
            "state": "MA",
            "country": "US",
            "updated": null
        },
        {
            "id": "3A5D2DF0974D416EEABFFD2DC6803B4B",
            "logo": null,
            "website": "acuren.com",
            "companyName": "acuren inspection inc",
            "industry": "Oil & Energy",
            "revenueRange": "$500MM-1B",
            "phone": "(937) 228-9729",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Nederland",
            "state": "TX",
            "country": "US",
            "updated": null
        },
        {
            "id": "7F1460167B62CED5DB0B4992F93FB265",
            "logo": null,
            "website": "acuraplus.com",
            "companyName": "acura plus",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(450) 435-4455",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Blainville",
            "state": "QC",
            "country": "CA",
            "updated": null
        },
        {
            "id": "7FE31F3729E31DA50EA46093AEBFC52B",
            "logo": null,
            "website": "acuraofrochester.com",
            "companyName": "acura of rochester",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(585) 385-5544",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Rochester",
            "state": "NY",
            "country": "US",
            "updated": null
        },
        {
            "id": "A92CC9F2394EB1606F0E49E0EBE9AF52",
            "logo": null,
            "website": "acuraoflynnwood.com",
            "companyName": "acura of lynnwood",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(425) 775-2925",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Lynnwood",
            "state": "WA",
            "country": "US",
            "updated": null
        },
        {
            "id": "EBC5B022DBA52A24D9E4C62D905F8C3D",
            "logo": null,
            "website": "acuracarland.com",
            "companyName": "acura carland",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(770) 623-9211",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Duluth",
            "state": "GA",
            "country": "US",
            "updated": null
        },
        {
            "id": "B91BCABFFE2878FC0B20DE4AFBF4C66F",
            "logo": null,
            "website": "acupunctureinmanhattan.com",
            "companyName": "acupuncture in manhattan",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": "(917) 331-2694",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "New York",
            "state": "NY",
            "country": "US",
            "updated": null
        },
        {
            "id": "689B8089908F89AF47D20F35EC3768E5",
            "logo": null,
            "website": "acupraise.com",
            "companyName": "acupraise",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": "(586) 983-5437",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Sterling Heights",
            "state": "MI",
            "country": "US",
            "updated": null
        },
        {
            "id": "9A853432ED37648AEC8E0C7D98AA8171",
            "logo": null,
            "website": "acupowder.com",
            "companyName": "acupowder tn llc",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": "(908) 851-4500",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Union",
            "state": "NJ",
            "country": "US",
            "updated": null
        },
        {
            "id": "F94736FF5537CC865B696DFF652B97E4",
            "logo": null,
            "website": "perceptivesoftware.com",
            "companyName": "acuo technologies llc",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": "(913) 422-7525",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Lenexa",
            "state": "KS",
            "country": "US",
            "updated": null
        },
        {
            "id": "42243724B5005F8B12DAE1C98507960D",
            "logo": null,
            "website": "acument.com",
            "companyName": "acument global technologies",
            "industry": "Automotive",
            "revenueRange": "Over $1B",
            "phone": "(810) 953-4575",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Rochester",
            "state": "IN",
            "country": "US",
            "updated": null
        },
        {
            "id": "C4B1005BA6E1B42A251466D168217DEE",
            "logo": null,
            "website": "acumensolutions.com",
            "companyName": "acumen solutions",
            "industry": "Information Technology and Services",
            "revenueRange": "$500MM-1B",
            "phone": "(703) 600-4000",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Seven Hills",
            "state": "OH",
            "country": "US",
            "updated": null
        },
        {
            "id": "270E6151D51EC44BFE122C5313C22690",
            "logo": null,
            "website": "acumenllc.com",
            "companyName": "acumen llc",
            "industry": "Public Policy",
            "revenueRange": "$50-100MM",
            "phone": "(650) 558-8882",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Burlingame",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "6D3A455CA67C73C45F7C44B98D6E052A",
            "logo": null,
            "website": "acumed.net",
            "companyName": "acumed",
            "industry": "Medical Devices",
            "revenueRange": "$50-100MM",
            "phone": "(503) 627-9957",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Hillsboro",
            "state": "OR",
            "country": "US",
            "updated": null
        },
        {
            "id": "C2E51C105D89F0EC3FAFD873EF63A024",
            "logo": null,
            "website": "acumatica.com",
            "companyName": "acumatica",
            "industry": "Computer Software",
            "revenueRange": "$500MM-1B",
            "phone": "(888) 228-8300",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Bellevue",
            "state": "WA",
            "country": "US",
            "updated": null
        },
        {
            "id": "156BEBE9E7392A097C6EF9A62F11AAA6",
            "logo": null,
            "website": "acuitycv.com",
            "companyName": "acuity software",
            "industry": "",
            "revenueRange": "Over $1B",
            "phone": "(613) 288-3770",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Ottawa",
            "state": "ON",
            "country": "CA",
            "updated": null
        },
        {
            "id": "FC14316B3F2AECAD17CF6ED771E7B977",
            "logo": null,
            "website": "acuityhealthcare.net",
            "companyName": "acuity healthcare lp",
            "industry": "Hospital & Health Care",
            "revenueRange": "$50-100MM",
            "phone": "(210) 572-4600",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Steubenville",
            "state": "OH",
            "country": "US",
            "updated": null
        },
        {
            "id": "8072AB4269344907977FDE25131367CF",
            "logo": null,
            "website": "acuitybrands.com",
            "companyName": "acuity brands",
            "industry": "Electrical/Electronic Manufacturing",
            "revenueRange": "Over $1B",
            "phone": "(404) 853-1400",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Newark",
            "state": "OH",
            "country": "US",
            "updated": null
        },
        {
            "id": "174F655967DC3918715489C9D9FFEE9C",
            "logo": null,
            "website": "acuity.com",
            "companyName": "acuity",
            "industry": "Insurance",
            "revenueRange": "$500MM-1B",
            "phone": "(920) 458-9131",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Sioux Falls",
            "state": "SD",
            "country": "US",
            "updated": null
        },
        {
            "id": "9A056E221175CFD611D7BCD2ABB05684",
            "logo": null,
            "website": "acudoracornltd.com",
            "companyName": "acudor acorn",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Brossard",
            "state": "QC",
            "country": "CA",
            "updated": null
        },
        {
            "id": "1A5A526D05EA841BB4E69C14CC727AA5",
            "logo": null,
            "website": "acuative.com",
            "companyName": "acuative",
            "industry": "Information Technology and Services",
            "revenueRange": "$50-100MM",
            "phone": "(973) 227-8040",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Southlake",
            "state": "TX",
            "country": "US",
            "updated": null
        },
        {
            "id": "B40D3E9AAA255FCE8A3F6BB770DFA7DB",
            "logo": null,
            "website": "acu-rite.com",
            "companyName": "acu-rite companies inc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(716) 661-1700",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Jamestown",
            "state": "NY",
            "country": "US",
            "updated": null
        },
        {
            "id": "0F0917FA472AD6AE2A23816A86362738",
            "logo": null,
            "website": "actuslendlease.com",
            "companyName": "actus lend lease",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(615) 324-8800",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Nashville",
            "state": "TN",
            "country": "US",
            "updated": null
        },
        {
            "id": "B1E6F1CF3170CC56CD2FBCEDD02389F6",
            "logo": null,
            "website": "actuate.com",
            "companyName": "actuate corp",
            "industry": "",
            "revenueRange": "Over $1B",
            "phone": "(888) 422-8828",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Allen",
            "state": "TX",
            "country": "US",
            "updated": null
        },
        {
            "id": "BA9E78D1D7F962E4BDF5F6DCBDDAC30D",
            "logo": null,
            "website": "ihcgroup.com",
            "companyName": "actuarial management corp",
            "industry": "Insurance Carriers and Related Activities",
            "revenueRange": "$500MM-1B",
            "phone": "(602) 265-2323",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Stamford",
            "state": "CT",
            "country": "US",
            "updated": null
        },
        {
            "id": "F58A247A5BA696289CFDA721E57E454F",
            "logo": null,
            "website": "actuant.com",
            "companyName": "actuant corp",
            "industry": "Mechanical or Industrial Engineering",
            "revenueRange": "Over $1B",
            "phone": "(262) 293-1500",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Cudahy",
            "state": "WI",
            "country": "US",
            "updated": null
        },
        {
            "id": "56076A2E4D2436396A46EF4CFD8D880E",
            "logo": null,
            "website": "solerainc.com",
            "companyName": "actual systems of america inc",
            "industry": "Information Technology and Services",
            "revenueRange": "Over $1B",
            "phone": "(817) 961-2100",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Buffalo Grove",
            "state": "IL",
            "country": "US",
            "updated": null
        },
        {
            "id": "BAFBAD2780B0904C93FB923EB9CC5A5D",
            "logo": null,
            "website": "actsretirement.com",
            "companyName": "acts retirement-life communities, inc",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "West Point",
            "state": "PA",
            "country": "US",
            "updated": null
        },
        {
            "id": "2D4F9DAFD51C9022FE040D19DD9B1DF1",
            "logo": null,
            "website": "actslife.org",
            "companyName": "acts retirement-life communities",
            "industry": "Hospital & Health Care",
            "revenueRange": "Over $1B",
            "phone": "(215) 661-8330",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "West Point",
            "state": "PA",
            "country": "US",
            "updated": null
        },
        {
            "id": "9002B598708BACCA5110A18066BFCD0C",
            "logo": null,
            "website": "actonmedical.com",
            "companyName": "acton medical associates pc",
            "industry": "Hospital & Health Care",
            "revenueRange": "$500MM-1B",
            "phone": "(978) 486-9255",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Littleton",
            "state": "MA",
            "country": "US",
            "updated": null
        },
        {
            "id": "FC9A2076260CEACB3F276C4F1FBEE6DC",
            "logo": null,
            "website": "actnano.com",
            "companyName": "actnano, inc",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": "(319) 337-1000",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Iowa City",
            "state": "IA",
            "country": "US",
            "updated": null
        },
        {
            "id": "AC293D634784127834ECFBE4878DD4D0",
            "logo": null,
            "website": "absupplies.com",
            "companyName": "activity based supplies",
            "industry": "Consumer Goods",
            "revenueRange": "$50-100MM",
            "phone": "(800) 469-8070",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Pittsburg",
            "state": "KS",
            "country": "US",
            "updated": null
        },
        {
            "id": "107A0890EA66F840712C222B150080BE",
            "logo": null,
            "website": "activisionblizzardmedia.com",
            "companyName": "activision blizzard media",
            "industry": "Marketing & Advertising",
            "revenueRange": "Over $1B",
            "phone": "(310) 255-2000",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Santa Monica",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "19C378447996E69F8C7168DFF41CA8DD",
            "logo": null,
            "website": "activision.com",
            "companyName": "activision blizzard inc",
            "industry": "Software Publishers",
            "revenueRange": "Over $1B",
            "phone": "(952) 918-9400",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Novato",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "A6FCBFF5AD6EC7B10CC7FFF966084F74",
            "logo": null,
            "website": "activehealth.com",
            "companyName": "activehealth management inc",
            "industry": "Health, Wellness and Fitness",
            "revenueRange": "$50-100MM",
            "phone": "(212) 651-8200",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "New York",
            "state": "NY",
            "country": "US",
            "updated": null
        },
        {
            "id": "CC1B3D742D37616FDB8C81559CB5AA34",
            "logo": null,
            "website": "activevoice.com",
            "companyName": "active voice",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(206) 441-4700",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Seattle",
            "state": "WA",
            "country": "US",
            "updated": null
        },
        {
            "id": "B98AE3F3C40639E1EAC021C1B333FBEB",
            "logo": null,
            "website": "activetools.com",
            "companyName": "active tools usa",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": "(248) 537-1048",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Meadville",
            "state": "PA",
            "country": "US",
            "updated": null
        },
        {
            "id": "649C599691CFD8318F7B92AC6F3E68BC",
            "logo": null,
            "website": "activeevents.com",
            "companyName": "active starcite",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": "(866) 224-3211",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Philadelphia",
            "state": "PA",
            "country": "US",
            "updated": null
        },
        {
            "id": "6387BDFA19DA1DC30B4CC823ACE6E750",
            "logo": null,
            "website": "activesoftinc.com",
            "companyName": "active soft inc",
            "industry": "Staffing and Recruiting",
            "revenueRange": "$50-100MM",
            "phone": "(404) 496-4368",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Alpharetta",
            "state": "GA",
            "country": "US",
            "updated": null
        },
        {
            "id": "6F096B3A3759B74D6D2C98F90BFB11B4",
            "logo": null,
            "website": "activesalesco.com",
            "companyName": "active sales co",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(619) 424-4774",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "San Jose",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "44997EACA9F9205A54282D9307AE4652",
            "logo": null,
            "website": "activerideshop.com",
            "companyName": "active ride shop",
            "industry": "Sporting Goods Stores",
            "revenueRange": "$50-100MM",
            "phone": "(714) 256-8516",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Yakima",
            "state": "WA",
            "country": "US",
            "updated": null
        },
        {
            "id": "786BC01E3E1A4A8EA90E87476929C070",
            "logo": null,
            "website": "activemailorder.com",
            "companyName": "active ride shop",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Rancho Cucamonga",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "FE146FE13E9097D65F469D0909485565",
            "logo": null,
            "website": "activerelease.com",
            "companyName": "active release techniques llc",
            "industry": "Health, Wellness and Fitness (124)",
            "revenueRange": "$500MM-1B",
            "phone": "(719) 442-1504",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Minneapolis",
            "state": "MN",
            "country": "US",
            "updated": null
        },
        {
            "id": "0D4F4D7E594273DCF1C4865ECE99C572",
            "logo": null,
            "website": "activepromos.com",
            "companyName": "active promotions",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": "(949) 859-5580",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Irvine",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "FB6A455698D7BBBB029DA9AA8BC56E73",
            "logo": null,
            "website": "activeplumbing.com",
            "companyName": "active plumbing supply co",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(440) 352-4411",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Cleveland",
            "state": "OH",
            "country": "US",
            "updated": null
        },
        {
            "id": "89686E8F646DE054124CBC4C5E8C0AEC",
            "logo": null,
            "website": "activeaero.com",
            "companyName": "active on-demand",
            "industry": "Airlines/Aviation",
            "revenueRange": "$500MM-1B",
            "phone": "(734) 547-7200",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Belleville",
            "state": "MI",
            "country": "US",
            "updated": null
        },
        {
            "id": "5BC27FC9F8E07DB2DA3A8E8C4E9EA126",
            "logo": null,
            "website": "activenetwork.sg",
            "companyName": "active network- singapore",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "San Diego",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "9B1242D23B24DFA4831DB518F93862FD",
            "logo": null,
            "website": "activenetwork.com",
            "companyName": "active network- australia",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "San Diego",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "0BA711F3647372111BAB43A35F067D4E",
            "logo": null,
            "website": "theactiveagency.com",
            "companyName": "active lifestyle marketing",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Mammoth Lakes",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "91815B22C17CD54E9F78AE157A246C20",
            "logo": null,
            "website": "activeinternational.ca",
            "companyName": "active international (active media services canada inc)",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Toronto",
            "state": "ON",
            "country": "CA",
            "updated": null
        },
        {
            "id": "2407F1FB7C9202EF8802F0EEFD0FFC67",
            "logo": null,
            "website": "activeinternational.com",
            "companyName": "active international",
            "industry": "Advertising & Marketing",
            "revenueRange": "$500MM-1B",
            "phone": "(845) 735-1700",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Pearl River",
            "state": "NY",
            "country": "US",
            "updated": null
        },
        {
            "id": "644DB1378C2678135B3A1FD201B386C9",
            "logo": null,
            "website": "activeinterestmedia.com",
            "companyName": "active interest media, inc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "El Segundo",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "C7F2DD7E2C3DDA8ADE861F7DF4849650",
            "logo": null,
            "website": "aimmedia.com",
            "companyName": "active interest media",
            "industry": "All Other Publishers",
            "revenueRange": "$50-100MM",
            "phone": "(303) 253-6301",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Boulder",
            "state": "CO",
            "country": "US",
            "updated": null
        },
        {
            "id": "A7D1498DE823B37E966C9D5274168FFB",
            "logo": null,
            "website": "activehealthmanagement.com",
            "companyName": "active health management, inc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Toronto",
            "state": "ON",
            "country": "CA",
            "updated": null
        },
        {
            "id": "8F2453EA6CB4EBA470D60C52EF071D40",
            "logo": null,
            "website": "alanaditescili.com",
            "companyName": "active communications corp",
            "industry": "",
            "revenueRange": "Over $1B",
            "phone": "(407) 425-5110",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Maitland",
            "state": "FL",
            "country": "US",
            "updated": null
        },
        {
            "id": "C311F06F1ADFB1760CD5C9CE2AD0276B",
            "logo": null,
            "website": "active-builders.com",
            "companyName": "active builders ltd",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": "(305) 940-8426",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Stockton",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "4B70F1025FAFF31B069B019B94178DFB",
            "logo": null,
            "website": "adoptimise.com",
            "companyName": "active",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Sacramento",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "F9EBB815336E8C97A129C0147339D0BD",
            "logo": null,
            "website": "healthcaregrp.com",
            "companyName": "activcare living inc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(858) 565-4424",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Vista",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "723FEAE004C9511F085F3C9DC1DD9D3C",
            "logo": null,
            "website": "activate-ed.org",
            "companyName": "activate ed",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": null,
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Oakland",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "1F3407540784E94AFF08E0CF58B22144",
            "logo": null,
            "website": "activar.com",
            "companyName": "activar inc",
            "industry": "Building Materials",
            "revenueRange": "$50-100MM",
            "phone": "(952) 944-3533",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Duluth",
            "state": "MN",
            "country": "US",
            "updated": null
        },
        {
            "id": "3871A27FF8C2EF979923C688707133BD",
            "logo": null,
            "website": "activair.com",
            "companyName": "activair global freight management and logistics",
            "industry": "",
            "revenueRange": "Over $1B",
            "phone": "(317) 487-9141",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Indianapolis",
            "state": "IN",
            "country": "US",
            "updated": null
        },
        {
            "id": "41A248326031C6D5691C331C6E1D9C53",
            "logo": null,
            "website": "actiontec.com",
            "companyName": "actiontec electronics",
            "industry": "Telecommunications",
            "revenueRange": "$500MM-1B",
            "phone": "(408) 752-7700",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Sunnyvale",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "CB20B6B393D520FBC5B855FB69A9DF96",
            "logo": null,
            "website": "actionlink.com",
            "companyName": "actionlink",
            "industry": "Broadcast Media",
            "revenueRange": "$50-100MM",
            "phone": "(888) 737-8757",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Akron",
            "state": "OH",
            "country": "US",
            "updated": null
        },
        {
            "id": "E813D10D832D0B00DF3381B14B221596",
            "logo": null,
            "website": "actionaid.org",
            "companyName": "actionaid",
            "industry": "Non-profit Organization Management",
            "revenueRange": "$50-100MM",
            "phone": "4.42031E+11",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Washington",
            "state": "DC",
            "country": "US",
            "updated": null
        },
        {
            "id": "C8FE13BC01A0014B7F0061CA813B1B61",
            "logo": null,
            "website": "actionablestrategies.com",
            "companyName": "actionable strategies",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": "(703) 875-4357",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Stamford",
            "state": "CT",
            "country": "US",
            "updated": null
        },
        {
            "id": "37BC2D9BA2633B375F604495E3212C74",
            "logo": null,
            "website": "actionstainless.com",
            "companyName": "action stainless & alloys inc",
            "industry": "Mining & Metals",
            "revenueRange": "$50-100MM",
            "phone": "(479) 750-1881",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Carrollton",
            "state": "TX",
            "country": "US",
            "updated": null
        },
        {
            "id": "F940B9D4E9EA351547C2FD44D5AF8C02",
            "logo": null,
            "website": "actionstaffing-group.com",
            "companyName": "action staffing-group",
            "industry": "Employment Placement Agencies",
            "revenueRange": "$50-100MM",
            "phone": "(908) 469-7251",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Elizabeth",
            "state": "NJ",
            "country": "US",
            "updated": null
        },
        {
            "id": "6FF3600A07E09E8171729A3EE38D0444",
            "logo": null,
            "website": "actionsportphysio.com",
            "companyName": "action sport physio",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(514) 955-8525",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Montreal West",
            "state": "QC",
            "country": "CA",
            "updated": null
        },
        {
            "id": "28606D98F8754F12DA2BA92A5DCE577D",
            "logo": null,
            "website": "actionsales.com",
            "companyName": "action sales",
            "industry": "Wholesale",
            "revenueRange": "$50-100MM",
            "phone": "(626) 308-1988",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Monterey Park",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "291437C38086AA9478D13924D7806372",
            "logo": null,
            "website": "action-resources.com",
            "companyName": "action resources inc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(256) 352-2689",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Cordele",
            "state": "GA",
            "country": "US",
            "updated": null
        },
        {
            "id": "0537126AEB39243B3C0C52A27A0E64BF",
            "logo": null,
            "website": "actionlife.com",
            "companyName": "action property management",
            "industry": "Real Estate",
            "revenueRange": "$500MM-1B",
            "phone": "(800) 400-2284",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Corona",
            "state": "CA",
            "country": "US",
            "updated": null
        },
        {
            "id": "31A703A2A29FE0F1EC740ED98282740F",
            "logo": null,
            "website": "actionnissan.com",
            "companyName": "action nissan",
            "industry": "",
            "revenueRange": "$500MM-1B",
            "phone": "(615) 834-8244",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Nashville",
            "state": "TN",
            "country": "US",
            "updated": null
        },
        {
            "id": "B3ACE1B7FB0F9C496AA9DE13BF0A00F8",
            "logo": null,
            "website": "safetyproductsdiv.com",
            "companyName": "action industrial supply",
            "industry": "Retail",
            "revenueRange": "$50-100MM",
            "phone": "(231) 722-6711",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Muskegon",
            "state": "MI",
            "country": "US",
            "updated": null
        },
        {
            "id": "E29E1A9D5930356018D229AA02A3364C",
            "logo": null,
            "website": "actionhealthstaffing.net",
            "companyName": "action health staffing",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(252) 243-0500",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Wilson",
            "state": "NC",
            "country": "US",
            "updated": null
        },
        {
            "id": "B1BDBDCC7C02D7EEFD4375B3337B16EC",
            "logo": null,
            "website": "actionhealthstaffing.com",
            "companyName": "action health staffing",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(252) 243-0500",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Rocky Mount",
            "state": "NC",
            "country": "US",
            "updated": null
        },
        {
            "id": "0961831B87FC6CAFA2135C78E35AD445",
            "logo": null,
            "website": "actiongrp.net",
            "companyName": "action group staffing",
            "industry": "Human Resources & Staffing",
            "revenueRange": "$500MM-1B",
            "phone": "(918) 893-8001",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Dover",
            "state": "NJ",
            "country": "US",
            "updated": null
        },
        {
            "id": "2A32E9FAA31BBF7E5FB34AA90778F4AC",
            "logo": null,
            "website": "action-group.ca",
            "companyName": "action group (alberta, canada)",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(403) 782-5531",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Lacombe",
            "state": "AB",
            "country": "CA",
            "updated": null
        },
        {
            "id": "84EA3D18881EBFB52EB84E465FE6AADC",
            "logo": null,
            "website": "actiongraphicsnj.com",
            "companyName": "action graphics inc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(973) 633-6500",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Lincoln Park",
            "state": "NJ",
            "country": "US",
            "updated": null
        },
        {
            "id": "018649AFAB7827189E6160FA910B9CC5",
            "logo": null,
            "website": "actionprints.com",
            "companyName": "action graphics",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(704) 332-1164",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Charlotte",
            "state": "NC",
            "country": "US",
            "updated": null
        },
        {
            "id": "9DCC4100BD371A6DF173466C371A9534",
            "logo": null,
            "website": "bostonabcd.org",
            "companyName": "action for boston community development inc",
            "industry": "Non-profit Organization Management",
            "revenueRange": "$50-100MM",
            "phone": "(617) 267-7400",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Mattapan",
            "state": "MA",
            "country": "US",
            "updated": null
        },
        {
            "id": "8730A9DAB04EFADA1D7693C60C3D288A",
            "logo": null,
            "website": "bestflagbuy.com",
            "companyName": "action flag co",
            "industry": "",
            "revenueRange": "$100-200MM",
            "phone": "(630) 985-0770",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Downers Grove",
            "state": "IL",
            "country": "US",
            "updated": null
        },
        {
            "id": "DDA79B14474533B05D4923864F9A990D",
            "logo": null,
            "website": "action-environmental.com",
            "companyName": "action environmental llc",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(606) 494-2098",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Hanceville",
            "state": "AL",
            "country": "US",
            "updated": null
        },
        {
            "id": "56D4882E3978E8E8E6B040C2519ECE4F",
            "logo": null,
            "website": "actn.com",
            "companyName": "action environmental",
            "industry": "Transportation",
            "revenueRange": "$500MM-1B",
            "phone": "(256) 401-0590",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Sylacauga",
            "state": "AL",
            "country": "US",
            "updated": null
        },
        {
            "id": "C3422995A86F3E2E0B9CC77B2F65EC1D",
            "logo": null,
            "website": "actionambulance.com",
            "companyName": "action ems",
            "industry": "",
            "revenueRange": "$50-100MM",
            "phone": "(978) 253-2600",
            "activeContacts": 0,
            "totalContacts": 0,
            "city": "Wilmington",
            "state": "MA",
            "country": "US",
            "updated": null
        }
    ],
    "facets": {
        "industry": [
            "",
            "Hospital & Health Care",
            "Retail",
            "Computer Software",
            "Information Technology and Services",
            "Medical Devices",
            "Financial Services",
            "Construction",
            "Transportation/Trucking/Railroad",
            "Management Consulting",
            "Marketing and Advertising",
            "Telecommunications",
            "Automotive",
            "Education Management",
            "Hospitality",
            "Real Estate",
            "Staffing and Recruiting",
            "Banking",
            "Broadcast Media",
            "Building Materials",
            "Consumer Goods",
            "Manufacturing",
            "Wholesale",
            "Biotechnology",
            "Consumer Services",
            "Food & Beverages",
            "Higher Education",
            "Individual & Family Services",
            "Industrial Automation",
            "Insurance",
            "Pharmaceuticals",
            "Renewables & Environment",
            "Retail Trade",
            "Chemicals",
            "Mechanical or Industrial Engineering",
            "Non-profit Organization Management",
            "Nonprofit Organization Management",
            "Oil & Energy",
            "Airlines/Aviation",
            "Computer & Network Security",
            "Electrical/Electronic Manufacturing",
            "Food Production",
            "Health, Wellness and Fitness",
            "Information Services",
            "Information Technology & Services",
            "Internet",
            "Logistics and Supply Chain",
            "Marketing & Advertising",
            "Media Production",
            "Primary/Secondary Education",
            "Software Publishers",
            "Advertising & Marketing",
            "Business Supplies and Equipment",
            "Corporate Services",
            "Employment Placement Agencies",
            "Environmental Services",
            "Facilities & Services",
            "Facilities Services",
            "Hotels (except Casino Hotels) and Motels",
            "Human Resources & Staffing",
            "Insurance Carriers and Related Activities",
            "Investment Management",
            "Luxury Goods & Jewelry",
            "Management Consulting Services",
            "Mechanical Or Industrial Engineering",
            "Medical Practice",
            "Mining & Metals",
            "Non-Profit Organization Management",
            "Packaging and Containers",
            "Plumbing",
            "Religious Institutions",
            "Restaurants",
            "Sporting Goods",
            "Utilities",
            "Venture Capital & Private Equity",
            "Advertising Agencies",
            "All Other Publishers",
            "Arts and Crafts",
            "Aviation & Aerospace",
            "Banking (41)",
            "Broadcast Media | Broadcast Media",
            "Broadcasting (except Internet)",
            "Civic and Social Organizations",
            "Civil Engineering",
            "Commercial & Residential Construction",
            "Commercial Real Estate",
            "Computer Games | Computer Games | Information Technology and Services | Information Technology and Services",
            "Computer Hardware",
            "Computer Networking",
            "Computer and Computer Peripheral Equipment and Software Merchant Wholesalers",
            "Consumer Electronics",
            "Consumer Goods Rental",
            "Consumer Services | Finance and Insurance",
            "Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly",
            "Dairy",
            "Design",
            "E-learning",
            "Education",
            "Electric Lighting Equipment Manufacturing",
            "Electrical Equipment Manufacturing"
        ],
        "employeeRange": [
            "50-199",
            "500-999",
            "1000-4999",
            "10-49",
            "5000-9999",
            "200-499",
            "Unknown",
            "Under 10",
            "Over 10000"
        ],
        "revenueRange": [
            "$50-100MM",
            "$500MM-1B",
            "$100-200MM",
            "Over $1B",
            "$200-500MM"
        ],
        "ownership": null,
        "countryState": null
    }
}
}


